


























import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { PageBuilderJSONType } from '~/utils/types';
import HTMLContent from '../HTMLContent.vue';
import { copyCode } from '~/utils/helpers/functions';
import { useUiNotification } from '~/composables';

export default defineComponent({
    props: {
        offerNode: {
            type: Object as PropType<PageBuilderJSONType>,
            required: true
        }
    },
    components: {
        HTMLContent
    },
    setup(props) {
        const { send: sendNotification } = useUiNotification();
        let offerDatas = null;
        let offerSubtitle;
        let offerBottom;
        let suffix = ''
        const suffixes = {
            percentage: '%',
            amount: '€'
        }
        try {
            offerDatas = JSON.parse(props.offerNode.children.find(c => c.cssClasses.includes('my-account-offer-datas')).DOMContent.innerHTML);
            suffix = suffixes[offerDatas.type] || '';
        } catch (e) {
            console.error('Error parsing offerNode', e)
        }
        offerSubtitle = props.offerNode.children.find(c => c.cssClasses.includes('my-account-offer-subtitle'));
        offerBottom = props.offerNode.children.find(c => c.cssClasses.includes('my-account-offer-bottom'));
        return {
            offerDatas,
            offerSubtitle,
            offerBottom,
            suffix,
            sendNotification
        }
    },
    methods: {
        copyCode() {
            if (!this.offerDatas || !this.offerDatas.code) return;
            copyCode(this.offerDatas.code, () => {
                this.sendNotification({
                    id: Symbol('code_copied'),
                    message: 'Codice copiato!',
                    persist: false,
                    type: 'success',
                    icon: 'check',
                });
            }, () => {
                this.sendNotification({
                    id: Symbol('code_not_copied'),
                    message: 'Errore nella copia!',
                    persist: false,
                    type: 'danger',
                    icon: 'cross',
                });
            });
        }
    }
})
